export const ManufacturedHomeContactsBannerTestIds = {
  ROOT: 'manufactured-home-contacts.info-banner',
};
